import React from "react";
import { NavLink, Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import GBETNativeInterface from "../../libs/gbetnativeinterface";

class MainHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modes: this.props.modes
        };

        this.iOSBiometricAuthenticationSettings = this.iOSBiometricAuthenticationSettings.bind(this);
    }

    componentDidUpdate(prevProps) {

        if (prevProps.modes !== this.props.modes) {
            this.setState({ modes: this.props.modes });
        }

    }

    clicklink(e, value) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "main-header", eventAction: "click", eventLabel: value });
        //want a full page reload to stop listOrderChangeSince
        e.preventDefault();
        window.location = e.currentTarget.href;
    }

    showSecurityPopup() {
        window.GBEMobileApp.nativeToJavaScript.showSecurityAndPasswordSettings();
    }

    iOSBiometricAuthenticationSettings(data) {
        if (!this.props.userContext) {
            // mapRoute.login({ successURL: "iOSBiometricAuthenticationSettings", options: null, neededOrderCache: false });
            return;
        }
        console.log(data);
        //var enrolmentResponse = GBEMobileAppUtils.urlParam("enrolmentResponse", data.toPage),
        //    biometryType = GBEMobileAppUtils.urlParam("biometryType", data.toPage);

        //GBEMobileGEP.pages.securityAndPassword.injectiOSBiometricAuthenticationSettings({ // onChangeActivateBiometricAuthentication
        //    enrolmentResponse: enrolmentResponse,
        //    biometryType: biometryType || "Touch or Face ID",
        //    eventHandlers: {
        //        onChangeActivateBiometricAuthentication: gepEventHandlers.pages.securityAndPassword.onChangeActivateBiometricAuthentication
        //    }
        //}, data.options);
    }

    render() {
        const thisComponent = this;
        const checkActive = (key, match, location) => {
            //some additional logic to verify you are in the home URI
            if (!location) {
                return false;
            }

            const mode = thisComponent.state.modes[key].toLowerCase();
            const { pathname } = location;
            const regEx = new RegExp("^/" + mode.replace("sportsbook", "sports|sportsbook").replace("exchange", "exchange|multiples") + "($|\/)", "i");

            const found = pathname.match(regEx);
            return thisComponent.state.modes[0].toLowerCase() === mode && pathname === "/" || found !== null;
        };

        const getLink = (mode) => {
            return "/" + mode.toLowerCase().replace("sportsbook", configurationSettings.sportsbookTabName).replace(/\s/g, "-");
        };

        var wageringTabs = 0;

        if (this.state.modes.indexOf("Sportsbook") > -1) {
            wageringTabs = wageringTabs + 1;
        }
        if (this.state.modes.indexOf("Exchange") > -1) {
            wageringTabs = wageringTabs + 1;
        }
        if (this.state.modes.indexOf("Pools") > -1) {
            wageringTabs = wageringTabs + 1;
        }

        const getTabText = (mode) => {
            if (wageringTabs === 1 && mode === "Pools") {
                mode = "Bet";
            }

            return mode;
        };

        const menuClass = this.props.fromLeftNav ? "menu" : "col menu d-none d-lg-flex";

        if (!isMobile) {
            const indexOfMultiples = this.state.modes.indexOf("Multiples");
            if (indexOfMultiples !== -1) {
                this.state.modes.splice(indexOfMultiples, 1);
            }
        }

        return (
            <div className={menuClass}>
                {this.state.modes.map((mode, key) => {
                    return (
                        <NavLink key={key} className={(isActive) => {
                            return (isActive ? "menu-item active" : "menu-item");
                        }} isActive={(match, location) => checkActive(key, match, location)} to={getLink(mode)} onClick={(e) => this.clicklink(e, mode)} >{getTabText(mode)}</NavLink>
                    );
                })
                }
                {GBEglobal.settings.dynamicHeader && GBEglobal.settings.dynamicHeader.map((item, key) => {
                    const classFromAttributes = item.attributes !== undefined ? " " + item.attributes.replace(/\|/g, " ") : "";

                    if (item.link.indexOf("http") !== 0) {
                        return (
                            <NavLink key={key} className={(isActive) => {
                                return (isActive ? "menu-item active" : "menu-item") + classFromAttributes;
                            }} to={item.link.toLowerCase()} onClick={(e) => this.clicklink(e, item)} >{item.name}</NavLink>
                        );
                    }

                    if (item.attributes !== undefined && item.attributes.indexOf("self") > -1) {
                        return (
                            <a key={key} className={"menu-item" + classFromAttributes} href={item.link} rel="nofollow" >{item.name}</a>
                        );
                    }
                    return (
                        <a key={key} className={"menu-item" + classFromAttributes} href={item.link} target={item.name} rel="nofollow" >{item.name}</a>
                    );

                })
                }
                {thisComponent.props.userContext && thisComponent.props.userContext !== undefined && GBETNativeInterface.isAndroidWebView && GBEglobal.androidWebViewSupportsBiometricAuthentication && GBEglobal.settings.biometricAuthentication && GBEglobal.settings.biometricAuthentication.android.enabled &&
                    <Link className="menu-item mobileonly" to="/" onClick={this.showSecurityPopup}>Security Settings</Link>
                }
                {/*{thisComponent.props.userContext && thisComponent.props.userContext !== undefined &&*/}
                {/*    <Link className="menu-item mobileonly" onClick={this.showSecurityPopup}>Security Settings</Link>*/}
                {/*}*/}
            </div>
        );
    }
}

export { MainHeader };